






























































































































import Vue from 'vue'
import './CastInputSelector.scss'
import { Table, TableColumn, Select, Option, Popover } from 'element-ui'
import { Stream, StreamType } from '@/types/streams'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'
import { sortBy } from 'lodash'
import { Feature } from '@/featureFlags/featureFlags'
import { KeyDict } from '@/types'

export default Vue.extend({
  name: 'CastInputSelector',
  data: () => ({
    newInput: '',
    showAddForm: false,
    error: ''
  }),
  computed: {
    isSelfServe (): boolean {
      return this.$hasFeature(Feature.SELF_SERVE)
    },
    showAddExisting (): boolean {
      return this.newInput !== ''
    },
    listStreams (): Stream[] {
      const team = this.$store.direct.state.team.team
      let inputs: Stream[] = []
      Object.keys(this.streams).forEach(streamid => {
        const stream = this.streams[streamid]
        if (!stream.deleted && stream.type === StreamType.Broadcast && stream.hasOwnProperty('name') && !stream.srcurl.startsWith('rtsp://')) {
          if (stream.auth_info !== undefined) {
            // Check that the team still has valid streams authentication (i.e. no error and not processing), and that
            // the stream has an `ingest_url`. Otherwise don't allow the stream to be selected.
            const streams_auth = team?.streams_auth?.[stream.auth_info.type]
            if (streams_auth === undefined || streams_auth.error || streams_auth.pending || !stream.auth_info.ingest_url || stream.auth_info.error) {
              // console.warn(`Skipping authenticated stream '${streamid}' due to no (valid) team streams authentication.`)
              return
            }
          }
          if (this.value[streamid] === undefined) {
            inputs.push(stream)
          }
        }
      })
      inputs = sortBy(inputs, [o => o.name.toLowerCase()])
      return inputs
    },
    addedInputs (): Stream[] {
      let streams: Stream[] = []
      Object.keys(this.value).forEach(streamkey => {
        const stream : Stream | undefined = this.streams[streamkey]
        if (stream !== undefined) {
          const data: Stream = {
            ...stream,
            id: streamkey
          }
          // Make sure to show `ingest_url` instead of the "republish" srcurl for streams with authentication.
          if (data.auth_info?.ingest_url) data.srcurl = data.auth_info.ingest_url
          streams.push(data)
        } else{
          // this shouldn't happen but it did (sentry)
          console.error(`CastInputSelector: no stream with id ${streamkey}... skipping`)
        }
      })
      streams = sortBy(streams, [o => o.name.toLowerCase()])
      return streams
    },
    numIngests (): any {
      return this.$store.direct.getters.events.numIngests
    },
    canAddIngest (): boolean {
      if (this.$can(AbilityAction.Do, AbilitySubject.Ops)) {
        return true
      }
      return this.addedInputs.length < this.maxAllowIngests
    },
    validNumberOfInputs (): boolean {
      return this.addedInputs.length <= this.maxAllowIngests
    },
    maxAllowIngests (): number {
      if (this.isSelfServe) return 2 //Max 2 inputs for self-serve
      const castFps = '' + this.fpsRounded
      if (this.numIngests.hasOwnProperty(this.resolution)) {
        if (this.numIngests[this.resolution].hasOwnProperty(castFps)) {
          return this.numIngests[this.resolution][castFps]
        }
      }
      return 1
    },
    fpsRounded (): number {
      const fps = parseFloat(this.castFps) //Remove 'Hz'
      return (Math.ceil(fps) <= 30) ? 30 : 60
    },
  },
  props: {
    streams: {
      type: Object as () => KeyDict<Stream>
    },
    value: {
      type: Object
    },
    castQuality: {
      type: String,
      required: true
    },
    castFps: {
      type: String,
      required: true
    },
    resolution: {
      type: String,
      required: true
    }
  },
  watch: {
    validNumberOfInputs (newval: boolean) {
      console.log('Valid Number of Inputs', newval)
      this.$emit('validNumberOfInputs', newval)
    }
  },
  methods: {
    removeStream (id) {
      const newValues = { ...this.value }
      delete newValues[id]
      this.$emit('input', newValues)
    },
    addStream () {
      if (this.newInput && this.streams[this.newInput] !== undefined) {
        const newValues = { ...this.value }
        newValues[this.newInput] = true
        this.$emit('input', newValues)
        this.newInput = ''
      } else {
        this.error = 'Please select a stream'
      }
    },
    isCurrentQuality (resolution: string, framerate: string): boolean {
      let fps = parseFloat(framerate)
      if (Math.ceil(fps) <= 30) {
        fps = 30
      } else {
        fps = 60
      }
      return this.resolution === resolution && this.fpsRounded === fps
    }
  },
  components: {
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-select': Select,
    'el-option': Option,
    'el-popover': Popover
  }
})
